import { ensureAuthenticated } from "./authenticate";

export const getAuthenticationToken = async () => {
  const auth = await ensureAuthenticated();
  const token = auth.getSignInUserSession().getIdToken().getJwtToken();
  if (token) {
    return token;
  }
  return null;
};
